import { TextArea } from "@ember/legacy-built-in-components";
export default TextArea.extend({
  attributeBindings: ["aria-label"]
});